import {createSelector} from 'reselect';

import {type RootState} from '../../types/redux';

export const getViewer = (state: RootState) => {
  return state.viewer.viewer;
};

export const getViewerLoading = (state: RootState) => {
  return state.viewer.loading;
};

export const reloadViewer = (state: RootState) => {
  return state.viewer.reload;
};

export const getViewerClaims = (state: RootState) => {
  return state.viewer.claims;
};

export const selectViewerEmail = (state: RootState) =>
  state.viewer.viewer?.email;

/**
 * Selects only the viewer fields needed by the App component.
 * Uses granular input selectors so that changes to irrelevant viewer
 * fields (e.g. photoUrl, organizations, teams) don't trigger
 * recomputation or re-renders.
 */
export const selectAppViewerState = createSelector(
  (state: RootState) => state.viewer.loading,
  (state: RootState) => state.viewer.reload,
  (state: RootState) => state.viewer.viewer != null,
  (state: RootState) => state.viewer.viewer?.admin,
  (state: RootState) => state.viewer.viewer?.signupRequired,
  (state: RootState) => state.viewer.viewer?.createdAt,
  (state: RootState) => state.viewer.viewer?.userInfo,
  (loading, reload, hasViewer, admin, signupRequired, createdAt, userInfo) => ({
    loading,
    reload,
    hasViewer,
    admin,
    signupRequired,
    createdAt,
    userInfo,
  })
);
